import type { JSONSchema7 } from 'json-schema';
import Ajv from 'ajv';
import type { ConditionalAssetMatcher, ConditionalMatcher, ConditionalWorkflowStepMatcher, AssetState } from './types';

const ajv = new Ajv();

export const workflowValidationSchema = {
  isConditionalWorkflowStepMatcher: (matcher: ConditionalMatcher): matcher is ConditionalWorkflowStepMatcher => {
    return 'workflowStepKey' in matcher;
  },
  isConditionalAssetMatcher: (matcher: ConditionalMatcher): matcher is ConditionalAssetMatcher => {
    return 'assetType' in matcher;
  },
  compile: (conditionalMatchers: ConditionalMatcher[], workflowKey: string, assetState: AssetState) => {
    // TODO _or _and matcher types
    const stateValidationProperties = conditionalMatchers.filter(
      workflowValidationSchema.isConditionalWorkflowStepMatcher,
    );
    const assetValidationProperties = conditionalMatchers.filter(workflowValidationSchema.isConditionalAssetMatcher);

    // Workflow state
    const workflowStateKeys = new Set<string>();
    const workflowStateProperties = stateValidationProperties.reduce<any>((prev, curr: any) => {
      const wfKey = curr.workflowKey || workflowKey;
      workflowStateKeys.add(wfKey);
      prev[wfKey] = prev[wfKey] || { type: 'object', properties: {}, additionalProperties: true, required: [] };
      prev[wfKey].properties[curr.workflowStepKey] = curr.schema ? curr.schema : curr.generateSchema(assetState);
      prev[wfKey].required.push(curr.workflowStepKey);
      return prev;
    }, {});

    // Workflow assets
    const workflowAssetKeys = new Set<string>();
    const workflowAssetProperties = assetValidationProperties.reduce<any>((prev, curr) => {
      const assetType = curr.assetType;
      workflowAssetKeys.add(assetType);
      prev[assetType] = curr.schema;
      return prev;
    }, {});

    const schema: JSONSchema7 = {
      type: 'object',
      properties: {
        additionalProperties: true,
      },
    };

    if (schema.properties && workflowStateKeys.size > 0) {
      schema.properties.workflowState = {
        type: 'object',
        properties: workflowStateProperties,
        additionalProperties: true,
        required: [...workflowStateKeys],
      };
    }

    if (schema.properties && workflowAssetKeys.size > 0) {
      schema.properties.workflowAssets = {
        type: 'object',
        properties: workflowAssetProperties,
        additionalProperties: true,
        required: [...workflowAssetKeys],
      };
    }

    return ajv.compile(schema);
  },
};
